// src/analytics.js
export const GA_TRACKING_ID = 'G-ZH2PHB9PLT';
const analyticsEnabled = process.env.REACT_APP_ENABLE_ANALYTICS === "true";

// Load GA script dynamically
export const initGA = () => {
  if (!analyticsEnabled) return;

  if (!window.GA_INITIALIZED) {
    window.dataLayer = window.dataLayer || [];
    function gtag(){ window.dataLayer.push(arguments); }
    window.gtag = gtag;

    gtag("js", new Date());
    gtag("config", GA_TRACKING_ID);

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_TRACKING_ID}`;
    document.head.appendChild(script);

    window.GA_INITIALIZED = true;
  }
};

// Track route changes
export const pageView = (url) => {
  const path = String(url || '').slice(0, 500);
  const section = path.split('?')[0].split('/').filter(Boolean).slice(1, 3).join('/') || 'home';
  const key = `uc-analytics:${path}`;
  const lastSent = Number(sessionStorage.getItem(key) || 0);
  if (Date.now() - lastSent > 30000) {
    sessionStorage.setItem(key, String(Date.now()));
    fetch(`${process.env.REACT_APP_API_BASE_URL || ''}/api/analytics/track`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path, section, eventType: 'page_view' }),
      keepalive: true,
    }).catch(() => {});
  }
  if (!analyticsEnabled) return;

  if (window.gtag) {
    window.gtag("config", GA_TRACKING_ID, {
      page_path: url,
    });
  }
};
